import * as React from "react";
import * as Three from "three";
import { loadObjWithMaterial } from "../../utils/load-obj";
import path from "path";
import { useState } from "react";
import Line, * as line from "../../class/line";
import * as SharedStyle from "../../shared-style";
import * as Geometry from "../../utils/geometry";
import WindowHandle from "../../../demo/src/assets/windhandle.png";

import OneNum from "../../../demo/src/assets/onenumicon.png";

import TwoNum from "../../../demo/src/assets/twonumicon.png";

import RightArrow from "../../../demo/src/assets/right-arrow.png";

import LeftArrow from "../../../demo/src/assets/left-arrow.png";

let cached3DWindow = null;
import convert from "convert-units";

const epsilon = 20;
const STYLE_TEXT = { textAnchor: "middle" };
const STYLE_CIRCLE = {

  fill: 'rgb(0, 150, 253)',

  stroke: 'rgb(255, 255, 255)',

  cursor: 'move'

};
const twoNum1 ={
  transform: 'scale(1,-1)',
}
const STYLE_LINE = { stroke: SharedStyle.LINE_MESH_COLOR.selected };
const STYLE_RECT = {
  strokeWidth: 1,
  stroke: SharedStyle.LINE_MESH_COLOR.unselected,
  fill: "url(#diagonalFill)",
};
const STYLE_RECT_SELECTED = {
  ...STYLE_RECT,
  stroke: SharedStyle.LINE_MESH_COLOR.selected,
};

export default function PlainWindowFactory(name, info, textures) {
  let plainWindowElement = {
    name,
    prototype: "lines",
    info,
    properties: {
      width: {
        label: "Width",
        type: "length-measure",
        defaultValue: {
          length: 90,
        },
      },
      height: {
        label: "Height",
        type: "length-measure",
        defaultValue: {
          length: 100,
        },
      },
      altitude: {
        label: "Altitude",
        type: "length-measure",
        defaultValue: {
          length: 90,
        },
      },
      thickness: {
        label: "Thickness",
        type: "length-measure",
        defaultValue: {
          length: 10,
        },
      },
    },

    render2D: function (element, layer, scene) {

      const [isDragging, setIsDragging] = useState(false);

      const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

      let { x: x1, y: y1 } = layer.vertices.get(element.vertices.get(0));

      let { x: x2, y: y2 } = layer.vertices.get(element.vertices.get(1));


      let length = Geometry.pointsDistance(x1, y1, x2, y2);

     

      let thickness = element.getIn(["properties", "thickness", "length"]);

      let half_thickness = (thickness * 19);


      // Create dimension labels

      const widthLabel = `${element.properties.get("width").get("length")}`;

      const heightLabel = `${element.properties.get("height").get("length")}`;

 

      const handleMouseDown = (e) => {

        console.log(e)

        setIsDragging(true);

        setDragStart({ x: e.clientX, y: e.clientY });

      };

   

      const handleMouseUp = () => {

        setIsDragging(false);

      };

   

      const handleMouseMove = (e) => {

        if (!isDragging) return;

   

        // let length= length + (e.clientX - dragStart.x);

        // console.log(length)

        // const newHeight = length + (e.clientY - dragStart.y);

      };

 

      if (length < 100) {

        var x = document.getElementById("snackbarSmall");

        x.className = "show";

        setTimeout(function () {

          x.className = x.className.replace("show", "");

        }, 3000);

      }

      if (length > 200) {

        var x = document.getElementById("snackbar");

        x.className = "show";

        setTimeout(function () {

          x.className = x.className.replace("show", "");

        }, 3000);

      }

 

 

      return (element.selected) ?

        <g>

          <defs>

            <linearGradient id="MyGradient" x2="100%" y2="0%">

              <stop offset="50%" stop-color="#9bedff" />

              <stop offset="50%" stop-color="#add8e6" />

            </linearGradient>

          </defs>

          {/* Border Frame */}

          <rect

            x="0"

            y={-half_thickness}

            width={length}

            height={thickness * 19}

            // stroke={SharedStyle.LINE_MESH_COLOR.selected}

            strokeWidth="10" // Adjust the border width as needed

            fill="url(#MyGradient)"

            stroke="#A52A2A" // Add this line to specify the border color (black in this example)

          />

          {/* Filled Rectangle */}

          <rect

            fill="url(#MyGradient)"

            x="0"

            y={-half_thickness}

            width={length}

            height={thickness * 19}

            // stroke={SharedStyle.LINE_MESH_COLOR.unselected}

            stroke="#A52A2A" // Add this line to specify the border color (black in this example)

            strokeWidth="10" // Add this line to specify the border width (2 in this example)

          />

<image
            x="-3"
            y={-half_thickness}
            width="22px"
            height={thickness * 19}
            xlinkHref={WindowHandle}
          />

<image
            x={length / 4}
            y={-0}
            width="22px"
            height={thickness * 19}
            xlinkHref={OneNum}
            style={twoNum1}
            // transform="rotate(180, 94.25, -190)"
          />
          <image
            x={length / 4}
            y={-half_thickness - 20}
            width="30px"
            height={thickness * 19}
            xlinkHref={RightArrow}
            // webkit-transform="rotate(90, 50, 50)"
          />
           <image
            x={(length / 4) * 3}
            y={-0}
            width="22px"
            height={thickness * 19}
            xlinkHref={TwoNum}
            style={twoNum1}
            // webkit-transform="rotate(90, 50, 50)"
          />

        <image
            x={(length / 4) * 3}
            y={-half_thickness - 20}
            width="28px"
            height={thickness * 19}
            xlinkHref={LeftArrow}
            // webkit-transform="rotate(90, 50, 50)"
          />

          <line

            x1={length / 2}

            x2={length / 2}

            y1={-half_thickness}

            y2="0"

            stroke="#A52A2A" // Add this line to specify the border color (black in this example)

            strokeWidth="7" // Add this line to specify the border width (2 in this example)

          />

 

 

          {/* width stroke */}

          <line x1={length+20} x2={length+20} y1={-half_thickness} y2="0" style={{stroke: "rgb(0, 150, 253)", strokeWidth: "1px"}}/>

 

          <line x1={length+14} y1="0" x2={length+26} y2="0" style={{stroke: "rgb(0, 150, 253)", strokeWidth: "1px"}}></line>

 

          <line x1={length+14} y1={-half_thickness} x2={length+26} y2={-half_thickness} style={{stroke: "rgb(0, 150, 253)", strokeWidth: "1px"}}></line>

 

          <text

        x={-half_thickness/2}

        y={length+31}

        style={{textAnchor:"middle",transform:"scale(1,-1) rotate(-90.03deg)",fontSize:"12px",fontFamily:"Courier New, Courier,monospace",pointerEvents:"none",fontWeight:"bold",userSelect:"none"}}

      >

        {"H " + half_thickness/100 + " mt"}

      </text>

 

      {/* dragging from all corners */}

      <circle cx={length} cy={-half_thickness} r="7" style={STYLE_CIRCLE}

      onMouseDown={handleMouseDown}

      onMouseMove={handleMouseMove}

      onMouseUp={handleMouseUp}

      />

      <circle cx="0" cy={-half_thickness} r="7" style={STYLE_CIRCLE}   />

        </g>

       

     

      :

 

          <g>

          <defs>

            <linearGradient id="MyGradient" x2="100%" y2="0%">

              <stop offset="50%" stop-color="#9bedff" />

              <stop offset="50%" stop-color="#add8e6" />

            </linearGradient>

          </defs>

          {/* Border Frame */}

          <rect

            x="0"

            y={-half_thickness}

            width={length}

            height={thickness * 19}

            // stroke={SharedStyle.LINE_MESH_COLOR.selected}

            strokeWidth="10" // Adjust the border width as needed

            fill="url(#MyGradient)"

            stroke="#A52A2A" // Add this line to specify the border color (black in this example)

          />

          {/* Filled Rectangle */}

          <rect

            fill="url(#MyGradient)"

            x="0"

            y={-half_thickness}

            width={length}

            height={thickness * 19}

            // stroke={SharedStyle.LINE_MESH_COLOR.unselected}

            stroke="#A52A2A" // Add this line to specify the border color (black in this example)

            strokeWidth="10" // Add this line to specify the border width (2 in this example)

          />

          <line

            x1={length / 2}

            x2={length / 2}

            y1={-half_thickness}

            y2="0"

            stroke="#A52A2A" // Add this line to specify the border color (black in this example)

            strokeWidth="7" // Add this line to specify the border width (2 in this example)

          />

        </g>

    },

    render3D: function (element, layer, scene) {
      let width = { length: 0.3, unit: "cm" };
      let depth = { length: 0.29, unit: "cm" };
      let height = { length: 0.03, unit: "cm" };

      let onLoadItem = (object) => {
        let newWidth = convert(width.length).from(width.unit).to(scene.unit);
        let newHeight = convert(height.length).from(height.unit).to(scene.unit);
        let newDepth = convert(depth.length).from(depth.unit).to(scene.unit);

        let newAltitude = element.properties.get("altitude").get("length");

        if (element.selected) {
          let box = new Three.BoxHelper(object, 0x99c3fb);
          box.material.linewidth = 2;
          box.material.depthTest = false;
          box.renderOrder = 1000;
          object.add(box);
        }

        object.scale.set(
          newWidth / width.length,
          newHeight / height.length,
          newDepth / depth.length
        );

        // Normalize the origin of the object
        let boundingBox = new Three.Box3().setFromObject(object);

        let center = [
          (boundingBox.max.x - boundingBox.min.x) / 2 + boundingBox.min.x,
          (boundingBox.max.y - boundingBox.min.y) / 2 + boundingBox.min.y,
          (boundingBox.max.z - boundingBox.min.z) / 2 + boundingBox.min.z,
        ];

        object.position.x -= center[0];
        object.position.y -=
          center[0] - (boundingBox.max.y - boundingBox.min.y) / 2;
        object.position.z -= center[1];

        object.position.y += newAltitude;

        object.rotation.y = Math.PI;

        return object;
      };

      if (cached3DWindow) {
        return Promise.resolve(onLoadItem(cached3DWindow.clone()));
      }

      let mtl = require("../../../demo/src/assets/window.mtl");
      let obj = require("../../../demo/src/assets/window.obj");
      let img = require("../../../demo/src/assets/texture.png");

      return loadObjWithMaterial(mtl, obj, img).then((object) => {
        cached3DWindow = object;
        return onLoadItem(cached3DWindow.clone());
      });
    },
  };
  return plainWindowElement;
}